import { render } from "./DocumentPanel.vue?vue&type=template&id=15d4e755&scoped=true"
import script from "./DocumentPanel.vue?vue&type=script&lang=js"
export * from "./DocumentPanel.vue?vue&type=script&lang=js"

import "./DocumentPanel.vue?vue&type=style&index=0&id=15d4e755&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d4e755"]])

export default __exports__